import { SubstitutionReason } from '@bp/planung-graphql-types';
import i18next from 'i18next';

export function getTextForSubstitutionReason(substitutionReason: SubstitutionReason) {
  if (substitutionReason === SubstitutionReason.Substituted) {
    return i18next.t('substitutions.reasons.substituted');
  }
  if (substitutionReason === SubstitutionReason.Aggregated) {
    return i18next.t('substitutions.reasons.aggregated');
  }
  if (substitutionReason === SubstitutionReason.Cancelled) {
    return i18next.t('substitutions.reasons.cancelled');
  }
  if (substitutionReason === SubstitutionReason.Moved) {
    return i18next.t('substitutions.reasons.moved');
  }
  if (substitutionReason === SubstitutionReason.SelfWork) {
    return i18next.t('substitutions.reasons.selfWork');
  }
  return '';
}
